import { render, staticRenderFns } from "./analysis.vue?vue&type=template&id=66c0cb1c&scoped=true"
import script from "./analysis.vue?vue&type=script&lang=js"
export * from "./analysis.vue?vue&type=script&lang=js"
import style0 from "./analysis.vue?vue&type=style&index=0&id=66c0cb1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c0cb1c",
  null
  
)

export default component.exports